import React, { useMemo } from "react";

const WeeksTab = ({ activeTab, onTabChange, weeks }) => {
  const tabs = useMemo(
    () => [
      { id: "home-tab", label: "PLAN OVERVIEW" },
      ...weeks.map((_, index) => ({
        id: `week-${index + 1}-tab`,
        label: `WEEK ${index + 1}`,
      })),
    ],
    [weeks]
  );

  return (
    <div className="col-sm-2">
      <ul className="nav nav-tabs" role="tablist">
        {tabs.map(({ id, label }) => (
          <li className="nav-item" role="presentation" key={id}>
            <button
              className={`nav-link ${activeTab === id ? "active" : ""}`}
              id={id}
              type="button"
              role="tab"
              aria-controls={`${id}-pane`}
              aria-selected={activeTab === id}
              onClick={() => onTabChange(id)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WeeksTab;
